var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.label ? 'label' : 'span',{tag:"component",staticClass:"cr-checkbox",class:( _obj = {
    'cr-checkbox-disabled': _vm.disabled
  }, _obj[("cr-color-" + _vm.color)] = _vm.color, _obj )},[_c('input',{attrs:{"id":_vm.inputId,"disabled":_vm.disabled,"name":_vm.name,"type":"checkbox"},domProps:{"checked":_vm.checked,"value":_vm.value},on:{"change":_vm.onChange}}),_c('i',{staticClass:"cr-checkbox-icon fas fa-check"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }